import { supabase } from '../../utils/supabase_config';

const BUCKET = 'care-report-receipts';

export class ReceiptStorageService {
  /**
   * Upload a receipt image for a shift.
   * @param {string} shiftId - UUID of the shift
   * @param {File} file - the image file to upload
   * @returns {Promise<string>} public URL of the uploaded file
   */
  static async uploadReceipt(shiftId, file) {
    // Normalize content type — iOS often sends HEIC or an empty type
    let contentType = file.type || 'image/jpeg';
    const nameParts = file.name.split('.');
    let ext = nameParts.length > 1 ? nameParts.pop().toLowerCase() : 'jpg';
    // HEIC/HEIF aren't reliably displayable in browsers; treat as jpeg
    if (ext === 'heic' || ext === 'heif') { ext = 'jpg'; contentType = 'image/jpeg'; }
    if (!ext) ext = 'jpg';

    const uniqueName = `${crypto.randomUUID()}.${ext}`;
    const path = `receipts/${shiftId}/${uniqueName}`;

    const { error } = await supabase.storage
      .from(BUCKET)
      .upload(path, file, { contentType, upsert: false });

    if (error) throw error;

    const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
    return data.publicUrl;
  }

  /**
   * Delete a receipt by its public URL.
   * @param {string} publicUrl
   */
  static async deleteReceipt(publicUrl) {
    // Extract the path after the bucket name
    const marker = `/${BUCKET}/`;
    const idx = publicUrl.indexOf(marker);
    if (idx === -1) throw new Error('Could not parse receipt URL');
    const path = publicUrl.slice(idx + marker.length);

    const { error } = await supabase.storage.from(BUCKET).remove([path]);
    if (error) throw error;
  }
}
